/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnitCostDtoPage } from '../../models/unit-cost-dto-page';

export interface ListUnitCosts$Params {
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'unitName' | '-unitName' | 'unitPluralName' | '-unitPluralName' | 'isActive' | '-isActive' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'unitCostRates' | '-unitCostRates' | 'unitCostLogsCount' | '-unitCostLogsCount'>;
}

export function listUnitCosts(http: HttpClient, rootUrl: string, params?: ListUnitCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<UnitCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listUnitCosts.PATH, 'get');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UnitCostDtoPage>;
    })
  );
}

listUnitCosts.PATH = '/v0/unitCosts';
